export function isApplicationCache(key: string): boolean {
  return key.startsWith('connect-360-');
}

export function isObsoleteApplicationCache(key: string, currentCache: string): boolean {
  return isApplicationCache(key) && key !== currentCache;
}
